import React from "react";
import "./App.css";
import { authProtectedRoutes, publicRoutes } from "./Routes/allRoutes";
import { Route, Routes } from "react-router-dom";
import VerticalLayout from "./Layouts/VerticalLayout";
import HorizontalLayout from "./Layouts/HorizontalLayout/index";
import "./assets/scss/theme.scss";
import NonAuthLayout from "./Layouts/NonLayout";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

//constants
import {
  LAYOUT_TYPES,
} from "./Components/constants/layout";

import fakeBackend from "./helpers/AuthType/fakeBackend";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import AuthProtected from "./Routes/AuthProtected";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from 'react-redux';

import { loadAuthData,authProfileThunks } from './store';
import axiosInstance from "./helpers/axiosInstanceHelper";
import { useThunk } from "./hooks/use_thunk";
import { getCookie } from "./helpers/browserStorageHelper";
// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

// Activating fake backend
fakeBackend();

const getLayout = (layoutType: any) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case LAYOUT_TYPES.VERTICAL:
      Layout = VerticalLayout;
      break;
    case LAYOUT_TYPES.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: true,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: true,
  timeOut: 5000,
  extendedTimeOut: 1000,
};

function App() {

  const selectLeadData = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      layoutTypes: layout.layoutTypes
    })
  );
  const { layoutTypes } = useSelector(selectLeadData);

  const Layout = getLayout(layoutTypes);
  const dispatch = useDispatch();
  const {runThunk, isLoading, error} = useThunk(authProfileThunks);
  window['axios']=axiosInstance;

  React.useEffect(() => {
    if(getCookie().accessToken)
    {
      dispatch(loadAuthData()); // App эхлэхэд cookie дээрх токенийг шалгана
      runThunk();
    }
  }, [dispatch]);

  

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} key={idx}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>} />
        ))}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <React.Fragment>
                <AuthProtected>
                  <Layout>
                    {route.component}
                  </Layout>
                </AuthProtected>
              </React.Fragment>
            }
          />
        ))}
      </Routes>
      <ToastContainer
        position="top-right" // Toast байрлал
        autoClose={5000} // Автомат хаагдах хугацаа
        hideProgressBar={false} // Прогресс бар харагдах эсэх
        newestOnTop={false} // Шинэ toast-ууд дээд талд харагдах эсэх
        closeOnClick // Хэрэглэгчийн товшилт дээр хаагдах
        rtl={false} // Баруун талаас зүүн тийш
        pauseOnFocusLoss // Хэвлэгчид анхаарал алдвал зогсох
        draggable // Тасалж болно
        pauseOnHover // Хөвж буй үед зогсох
      />
    </React.Fragment>
  );
}

export default App;
